import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { EntityWithTemplate, JobBoardPageComponent } from "@interfaces";

export type PageEvent = {
    pageIndex: number;
    pageSize: number;
    length: number;
};

@Component({
    selector: "app-paginator",
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: "./paginator.component.html",
    styleUrls: ["./paginator.component.css"],
})
export class PaginatorComponent implements OnChanges {
    @Input() component: JobBoardPageComponent;
    @Input() length: number;
    @Input() pageSize: number = 10;
    @Input() pageSizeOptions: number[];
    @Input() entity?: EntityWithTemplate;
    public pageIndex: number = 0;
    public pages = [];

    constructor(public route: ActivatedRoute) {
        this.route.queryParams.subscribe(({ pageIndex, pageSize }) => {
            if (pageIndex) {
                this.pageIndex = parseInt(pageIndex);
            }
            if (pageSize) {
                this.pageSize = parseInt(pageSize);
            }
        });
    }

    ngOnChanges() {
        this.pages = [];
        for (let i = 0; i < Math.ceil(this.length / this.pageSize); i++) {
            this.pages.push(i);
        }
    }
}
